import React, { useEffect } from "react";
import { EasyBefore } from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/Profile.css";
import ProfileTab from "./ProfileTab";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "./../../hooks/Form";
import {
	useGetProfileQuery,
	useProfileUpdateMutation,
} from "../../store/services/AuthServices";
import Spinner from "./../../utils/Loader";
import { setSuccess } from "../../store/reducers/globalReducers";

const EditPersonalDetail = () => {
	let { data, isFetching } = useGetProfileQuery();
	let [updatedData, response] = useProfileUpdateMutation();
	let user = data?.response?.data;

	const { state, onChange, setState } = useForm({
		first_name: "",
		last_name: "",
		email: "",
		contact_no: "",
	});

	let dispatch = useDispatch();
	const UpdateProfile = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("first_name", state.first_name);
		FormDatas.append("last_name", state.last_name);
		FormDatas.append("email", state.email);
		FormDatas.append("contact_no", state.contact_no);
		updatedData(FormDatas);
	};

	useEffect(() => {
		if (response.isSuccess) {
			dispatch(setSuccess(response?.data?.message));
			navigate("/account");
		}
	}, [response.isSuccess]);

	useEffect(() => {
		setState(user);
	}, [isFetching]);

	let navigate = useNavigate();

	return (
		<>
			{!isFetching ? (
				<div className="services Account">
					{/* Header */}
					<Header />
					{/* Header */}

					{/* Easy Plan Sec Start Here */}
					<section className="easy-plan mt-5">
						<div className="right-before">
							<figure>
								<img src={EasyBefore} alt="" className="img-fluid" />
							</figure>
						</div>
						<div className="container mt-5">
							<div className="row mb-3">
								<div className="col-lg-12 text-left">
									<p>
										Home{" "}
										<span className="fa fa-chevron-right chevron_right"> </span>{" "}
										Profile
									</p>
								</div>
							</div>
						</div>
					</section>

					{/* accout section starts*/}
					<section className="profile_section">
						<div className="container">
							<div className="row">
								<div className="col-lg-3">
									<ProfileTab />
								</div>
								<div className="col-lg-9">
									<div className="InfoDetails">
										<h3 className="heading_Account">Edit Personal Detail</h3>
										<div className="row">
											<div className="col-lg-6 my-2">
												<input
													type="text"
													placeholder="John"
													name="first_name"
													value={state?.first_name}
													onChange={onChange}
													className="inpt_field"
												/>
											</div>
											<div className="col-lg-6 my-2">
												<input
													type="text"
													placeholder="Doe"
													className="inpt_field"
													name="last_name"
													value={state?.last_name}
													onChange={onChange}
												/>
											</div>
											<div className="col-lg-6 my-2">
												<input
													type="text"
													placeholder="Johndoe@gmail.com"
													className="inpt_field"
													name="email"
													value={state?.email}
													onChange={onChange}
												/>
											</div>
											<div className="col-lg-6 my-2">
												<input
													type="text"
													placeholder="Contact Number"
													className="inpt_field"
													name="contact_no"
													value={state?.contact_no}
													onChange={onChange}
												/>
											</div>
											<div className="col-lg-6 mt-3 flit-btnss">
												<button class=" bt-prof-green" onClick={UpdateProfile}>
													Save Changes
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* accout section ends*/}

					{/* Footer */}
					<Footer />
					{/* Footer */}
				</div>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default EditPersonalDetail;
